import { Box, Button, FormControl, InputLabel, MenuItem, Paper, Select, TextField } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { IMarketplace } from "../../../../../marketplace/interfaces/IMarketplace";
import { ICategoria } from "../../../../interfaces/ICategoria";
import { FiltrosContainer } from "./styles";

interface FiltrosTabelaCardapioProps {
    filtroDescricao: string;
    setFiltroDescricao: (value: string) => void;
    filtroPrecoMin: string;
    setFiltroPrecoMin: (value: string) => void;
    filtroPrecoMax: string;
    setFiltroPrecoMax: (value: string) => void;
    filtroMarketplace: string;
    setFiltroMarketplace: (value: string) => void;
    filtroCategoria: string;
    setFiltroCategoria: (value: string) => void;
    marketplaces?: IMarketplace[];
    categorias?: ICategoria[];
}

export const FiltrosTabelaCardapio = ({
    filtroDescricao,
    setFiltroDescricao,
    filtroPrecoMin,
    setFiltroPrecoMin,
    filtroPrecoMax,
    setFiltroPrecoMax,
    filtroMarketplace,
    setFiltroMarketplace,
    filtroCategoria,
    setFiltroCategoria,
    marketplaces,
    categorias
}: FiltrosTabelaCardapioProps) => {
    const handleLimparFiltros = () => {
        setFiltroDescricao('');
        setFiltroPrecoMin('');
        setFiltroPrecoMax('');
        setFiltroMarketplace('');
        setFiltroCategoria('');
    };

    const temFiltrosAtivos = filtroDescricao || filtroPrecoMin || filtroPrecoMax || filtroMarketplace || filtroCategoria;

    return (
        <Paper sx={{ p: 2, mb: 2, width: '100%' }}>
            <FiltrosContainer>
                <TextField
                    label="Filtrar por descrição"
                    value={filtroDescricao}
                    onChange={(e) => setFiltroDescricao(e.target.value)}
                    size="small"
                    sx={{ flex: 1, minWidth: '200px' }}
                />
                <TextField
                    label="Preço mínimo"
                    type="number"
                    value={filtroPrecoMin}
                    onChange={(e) => setFiltroPrecoMin(e.target.value)}
                    size="small"
                    inputProps={{ min: 0, step: 0.01 }}
                    sx={{ width: '150px' }}
                />
                <TextField
                    label="Preço máximo"
                    type="number"
                    value={filtroPrecoMax}
                    onChange={(e) => setFiltroPrecoMax(e.target.value)}
                    size="small"
                    inputProps={{ min: 0, step: 0.01 }}
                    sx={{ width: '150px' }}
                />
                <FormControl size="small" sx={{ minWidth: 200 }}>
                    <InputLabel>Marketplace</InputLabel>
                    <Select
                        value={filtroMarketplace}
                        onChange={(e) => setFiltroMarketplace(e.target.value)}
                        label="Marketplace"
                    >
                        <MenuItem value="">Todos</MenuItem>
                        {marketplaces?.map((marketplace) => (
                            <MenuItem key={marketplace.uuid} value={marketplace.uuid}>
                                {marketplace.nome || marketplace.tipo}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 200 }}>
                    <InputLabel>Categoria</InputLabel>
                    <Select
                        value={filtroCategoria}
                        onChange={(e) => setFiltroCategoria(e.target.value)}
                        label="Categoria"
                    >
                        <MenuItem value="">Todas</MenuItem>
                        {categorias?.map((categoria) => (
                            <MenuItem key={categoria.uuid} value={categoria.uuid}>
                                {categoria.descricao}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                {temFiltrosAtivos && (
                    <Button
                        variant="text"
                        startIcon={<CloseIcon />}
                        onClick={handleLimparFiltros}
                        sx={{ 
                            color: 'text.secondary',
                            minWidth: 'auto'
                        }}
                    >
                        Limpar
                    </Button>
                )}
            </FiltrosContainer>
        </Paper>
    );
};

